<div class="new-comment">
    <adapt-person-image class="item-comment-person"
                        [person]="commentingPerson"></adapt-person-image>
    <div class="new-comment-text">
        <adapt-html-editor [contents]="newComment"
                           (contentsChange)="newCommentChange.emit($event)"
                           forceSize="compact"
                           placeholderText="Add a comment"
                           (isValidChange)="showSaveButton = $event"
                           [useMentions]="true"></adapt-html-editor>
        @if (showSaveButton) {
            <div class="d-flex gap-1 mt-1">
                @if (allowSave) {
                    <button adaptButtonIcon="save"
                            class="btn btn-primary btn-small btn-save-comment"
                            [hidden]="!showSaveButton"
                            [adaptBlockingClick]="save">Save comment</button>
                }
                <button class="btn btn-default btn-small btn-save-comment"
                        (click)="cancel()">Cancel</button>
            </div>
        }
    </div>
</div>
